import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import type { SyntheticEvent } from "react";
import type { FilterRenderProps } from "../../grid/CompGrid";

export interface GridIdsFilterPopoverProps extends FilterRenderProps {
  label: string;
  placeholder?: string;
}

export function GridIdsFilterPopover({
  value,
  onChange,
  onClose,
  label,
  placeholder = "Add ID and press Enter",
}: GridIdsFilterPopoverProps) {
  const ids = (Array.isArray(value) ? value : []) as string[];

  const handleChange = (_event: SyntheticEvent, newValue: string[]) => {
    onChange(newValue);
  };

  return (
    <Box sx={{ minWidth: 220 }}>
      <Autocomplete
        multiple
        freeSolo
        options={[]}
        value={ids}
        onChange={handleChange}
        size="small"
        renderTags={(tags: readonly string[], getTagProps) =>
          tags.map((option, index) => (
            <Chip
              key={option}
              {...getTagProps({ index })}
              label={option}
              size="small"
              className="om-text-mono"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            size="small"
          />
        )}
      />
    </Box>
  );
}
